export default __webpack_public_path__ + "static/media/images.6cb29d24.jpeg";